import React, { useState } from 'react';
import { Modal, Button } from 'antd';

interface ErrorModalProps {
    title?: string;
    message: string;
    visible?: boolean;
    onOk?: () => void;
}

export const ErrorModal: React.FC<ErrorModalProps> = (props: ErrorModalProps) => {
    const [errorModalVisible, setErrorModalVisible] = useState(props.visible ?? true);

    const handleErrorModalClose = () => {
        setErrorModalVisible(false);
        if (props.onOk) {
            props.onOk()
        }
    };


    return (
        <Modal
            cancelButtonProps={{}}
            okType='danger'
            title={props.title ?? "Error"}
            open={errorModalVisible}
            onOk={handleErrorModalClose}
            onCancel={handleErrorModalClose}
            onClose={handleErrorModalClose}
            footer={[
                <Button key="ok" type="primary" onClick={handleErrorModalClose}>
                    OK
                </Button>
            ]}
        >
            <p>{props.message}</p>
        </Modal>
    );
}

export const showErrorModal = ( message: string, title?: string, onOk?: () => void) => {
    return Modal.error({
        title: title,
        content: message,
        onOk: onOk,
        okCancel: false
    })
  
}